import {
  BEGIN_AVATAR_DRAG,
  END_AVATAR_UPLOAD,
  FINISH_AVATAR_DRAG,
  START_AVATAR_UPLOAD,
  UPDATE_AVATARS,
} from 'constants/actions';

export const updateAvatars = avatars => {
  return { type: UPDATE_AVATARS, avatars };
};

export const beginAvatarDrag = pos => {
  return { type: BEGIN_AVATAR_DRAG, pos };
};

export const finishAvatarDrag = () => {
  return { type: FINISH_AVATAR_DRAG };
};

export const startAvatarUpload = () => {
  return { type: START_AVATAR_UPLOAD };
};

export const endAvatarUpload = () => {
  return { type: END_AVATAR_UPLOAD };
};
